import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OffersComponent } from './offers.component';
import { UIModule } from '../../../ui/ui.module';
import { LoaderModule } from '../../../component/loader/loader.module';
import { RoomModule } from '../room/room.module';
import { OfferComponent } from './offer.component';
import { DatePipeModule } from 'libraries/date/date.module';
import { CancellationConditionsModule } from '../cancellation-conditions/cancellation-conditions.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { PriceDetailsModule } from '../price-details/price-details.module';
import { PricePipesModule } from 'libraries/pipes/price/price-pipes.module';
import { PricePipeModule } from 'libraries/pipes/price/price-pipe.module';
import { MealPlanModule } from 'libraries/component/meal-plan/meal-plan.module';
import { RequestStatusModule } from '../request-status/request-status.module';
import { HostAliasPipeModule } from "libraries/pipes/host-alias/host-alias-pipe.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import { PermissionModule } from "libraries/permission/permission.module";

@NgModule({
    imports: [
        CancellationConditionsModule,
        CommonModule,
        DatePipeModule,
        FontAwesomeModule,
        HostAliasPipeModule,
        LoaderModule,
        MealPlanModule,
        NotificationModule,
        PermissionModule,
        PriceDetailsModule,
        PricePipeModule,
        PricePipesModule,
        RequestStatusModule,
        RoomModule,
        UIModule,
    ],
    exports: [
        OffersComponent,
    ],
    declarations: [
        OffersComponent,
        OfferComponent,
    ],
})
export class OffersModule { }
